import React from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty, filter } from 'lodash';
import find from 'lodash/find';
import BaseLinksFooter from 'common-ui-components/dist/components/Organisms/BaseLinksFooter';
import SocialLinksFooter from 'common-ui-components/dist/components/Organisms/SocialLinksFooter';
import errorBoundary from '../../../utils/errorBoundary';
import { getLocalCountryLanguage } from '../../../utils/utils';
import {
  EPROC_USER_ROLE,
  DEFAULT_PATH_FORMAT,
  PAGE_TO_DISABLE_FOOTER_SELECTOR,
} from '../../../global/constants';
import './Footer.scss';

export const parseCountryList = countryListJson => {
  let countries = [];
  if (countryListJson.length > 0) {
    countries = JSON.parse(countryListJson);
  }
  return countries;
};

const getCountryName = (localeLanguageCountry, countries) => {
  const selectedCountry =
    countries && filter(countries, item => item.href.indexOf(localeLanguageCountry) !== -1);
  const country = selectedCountry.length ? selectedCountry[0] : countries[0];
  return get(country, 'title', '');
};

export const FooterComponent = props => {
  const { pageData, labels, hideNavigation, appHostPath, userType, contactSupportHref } = props;
  const allPageData = get(pageData, ['Page Content', '_children'], {});
  const footerData = find(allPageData, item => item.name === 'footer');
  const experienceFooterData = get(footerData, ['par'], {});
  const countries = parseCountryList(get(footerData, ['countryListJson'], {}));
  const languageList = get(footerData, ['languageListJson'], {});
  const { localeCountry, localeLanguage } = getLocalCountryLanguage();
  const localeLanguageCountry = `/${localeCountry}/${localeLanguage}`;
  const countryName = getCountryName(localeLanguageCountry, countries);
  const isEProcurementApp = get(props, 'isEProcurementApp', undefined);

  return (
    <footer className="cmp-footer" id="cmp-footer">
      {footerData && (
        <SocialLinksFooter
          {...Object.assign(footerData, {
            labels,
            appHostPath,
            hideNavigation,
            experienceFooterData,
            contactSupportHref,
            isVisibleContactWatersLink: userType === EPROC_USER_ROLE,
          })}
        />
      )}
      {footerData && !isEmpty(languageList) && (
        <BaseLinksFooter
          {...Object.assign(footerData, {
            labels,
            appHostPath,
            countryName,
            countries,
            languageList,
            isVisibleLanguageList: userType !== EPROC_USER_ROLE,
            isEProcurementApp,
            defaultPathFormat: DEFAULT_PATH_FORMAT,
            disableFooterSelector: PAGE_TO_DISABLE_FOOTER_SELECTOR,
          })}
        />
      )}
    </footer>
  );
};

FooterComponent.propTypes = {
  /* eslint react/forbid-prop-types: 0 */
  pageData: PropTypes.object,
  labels: PropTypes.object,
  appHostPath: PropTypes.string,
  hideNavigation: PropTypes.bool,
  userType: PropTypes.string,
  contactSupportHref: PropTypes.string,
  isEProcurementApp: PropTypes.bool,
};

FooterComponent.defaultProps = {
  appHostPath: '',
  hideNavigation: false,
  pageData: {},
  labels: {},
  userType: '',
  contactSupportHref: '',
  isEProcurementApp: false,
};

export default errorBoundary(FooterComponent);
